import React, { useState } from "react";
import useCreateTraining from "../hooks/useCreateTraining";
import useUploadFiles from "../../../services/hooks/useUploadFiles";

// state
import { useAppDispatch, useAppSelector } from "../../../store";

// components
import TextInput from "../../../component/element/forms/TextInput";
import SelectDate from "../../../component/element/forms/SelectDate";
import SelectOption from "../../../component/element/forms/SelectOption";
import Upload from "../../../component/modals/upload";
import { get_countries, get_states } from "../../../services/apis/country";
import { create_training } from "../../../services/apis/training";
import RichText from "../../../component/element/forms/RichText";
// import Button from "../../../component/element/forms/Button";
import Button from "../../../component/element/forms/Button";
import { useNavigate } from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";

const CreateTraining = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const states = useAppSelector(({ country }) => country.states);
  const countries = useAppSelector(({ country }) => country.all_countries);

  const { data, dataSet, errorSet, onValidate } = useCreateTraining();
  const { loader, uploadFile, deleteFiles } = useUploadFiles();
  const [imgPath, setImgPath] = useState("");

  const handleOk = async () => {
    const validate = onValidate();
    if (!validate) return;

    const response = await create_training(data, dispatch);
    if (response) {
      setTimeout(() => {
        window.location.href = "/training";
      }, 0);
    }
  };

  const onLoad = React.useCallback(() => {
    get_countries(dispatch);
  }, [dispatch]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  return (
    <div className="pb-12">
      <div className="flex justify-between items-center mb-6">
        <h2 className="font-bold text-xl mb-0">Create Training</h2>
        <Button
          title="Back"
          onClick={() => navigate(-1)}
          children={<FaArrowLeftLong className="mr-2" />}
          className="px-4"
          aria-label="Back"
        />
      </div>
      <div className="bg-white p-6 rounded-xl space-y-6">
        <Upload
          title="Upload Image"
          label="JPG & PNG"
          name="image"
          loading={loader}
          status=""
          completed={Boolean(data.image)}
          imgPreview={data.image}
          onChange={async (fileOrFiles) => {
            const paths = await uploadFile(fileOrFiles as File, "training");
            if (paths.length > 0) {
              const img_path = paths[0].base_url + "/" + paths[0].path;
              dataSet((prev) => ({ ...prev, image: img_path }));
              errorSet((prev) => ({ ...prev, image: "" }));
              setImgPath(paths[0].path);
            }
          }}
          onDelete={async () => {
            if (imgPath) {
              const res = await deleteFiles(imgPath);
              if (res) {
                dataSet((prev) => ({ ...prev, image: "" }));
              }
            }
          }}
        />

        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
          <TextInput
            label="Title"
            name="name"
            placeholder="Title"
            value={data.name}
            type="text"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const { value, name } = e.target;
              dataSet((prev) => ({ ...prev, [name]: value }));
              errorSet((prev) => ({ ...prev, [name]: "" }));
            }}
          />

          <TextInput
            label="Address"
            name="address"
            placeholder="Address"
            value={data.address}
            type="text"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const { value, name } = e.target;
              dataSet((prev) => ({ ...prev, [name]: value }));
              errorSet((prev) => ({ ...prev, [name]: "" }));
            }}
          />

          <TextInput
            label="Link"
            name="link"
            placeholder="Link"
            value={data.link}
            type="text"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const { value, name } = e.target;
              dataSet((prev) => ({ ...prev, [name]: value }));
              errorSet((prev) => ({ ...prev, [name]: "" }));
            }}
          />

          <TextInput
            label="Amount"
            name="amount"
            placeholder="Amount"
            value={data.amount}
            type="text"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const { value, name } = e.target;
              dataSet((prev) => ({ ...prev, [name]: value }));
              errorSet((prev) => ({ ...prev, [name]: "" }));
            }}
          />

          <TextInput
            label="Duration"
            name="duration"
            placeholder="Duration"
            value={data.duration}
            type="text"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const { value, name } = e.target;
              dataSet((prev) => ({ ...prev, [name]: value }));
              errorSet((prev) => ({ ...prev, [name]: "" }));
            }}
          />

          <SelectDate
            label="Date"
            placeholder="Date"
            onChange={(e) => {
              dataSet((prev) => ({ ...prev, date: e }));
              errorSet((prev) => ({ ...prev, date: "" }));
            }}
          />

          <SelectOption
            items={countries}
            label="Country"
            placeholder="Country"
            value={data.country_id}
            onChange={(res) => {
              dataSet((prev) => ({ ...prev, country_id: res }));
              errorSet((prev) => ({ ...prev, country_id: "" }));
              get_states(dispatch, res);
            }}
          />

          <SelectOption
            items={states}
            label="State"
            placeholder="State"
            value={data.state_id}
            onChange={(res) => {
              dataSet((prev) => ({ ...prev, state_id: res }));
              errorSet((prev) => ({ ...prev, state_id: "" }));
            }}
          />
        </div>
        <div className="mt-6">
          <RichText
            placeholder="Description"
            value={data.body}
            onChange={(value) => {
              dataSet((prev) => ({ ...prev, body: value }));
              errorSet((prev) => ({ ...prev, body: "" }));
            }}
          />
        </div>
        <div className="mt-6 flex justify-end">
          <Button
            title="Submit"
            type="button"
            onClick={handleOk}
            className="w-32 text-white"
          />
        </div>
      </div>
    </div>
  );
};

export default CreateTraining;
